import { render, staticRenderFns } from "./open_store.vue?vue&type=template&id=6b800351&scoped=true&"
import script from "./open_store.vue?vue&type=script&lang=js&"
export * from "./open_store.vue?vue&type=script&lang=js&"
import style0 from "./open_store.vue?vue&type=style&index=0&id=6b800351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b800351",
  null
  
)

export default component.exports